export const getDomain = (): string => {
  return window.location.hostname.replace('www.', '');
};
